import React from 'react';
import ReactDOM from 'react-dom/client';

import {HelmetProvider} from "react-helmet-async";
import { Provider as ReduxProvider } from "react-redux";


// redux
import { persistor, store } from "./redux/store";

import {SettingsProvider} from "./components/settings";
import {BrowserRouter} from "react-router-dom";
import {PersistGate} from "redux-persist/integration/react";
import LoadingScreen from "./components/LoadingScreen";
// @mui
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";


import './index.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
        <HelmetProvider>
            <ReduxProvider store={store}>
                <PersistGate loading={<LoadingScreen />} persistor={persistor}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <SettingsProvider>
                            <BrowserRouter>
                                <App />
                            </BrowserRouter>
                        </SettingsProvider>
                    </LocalizationProvider>
                </PersistGate>
            </ReduxProvider>
        </HelmetProvider>
);